import React, { useState, useEffect, useRef } from 'react';
import Axios from '../../Components/Axios/Axios';
import Auth from '../../Components/Auth/Auth';
import { useHistory } from 'react-router-dom';
import { USER_KEY } from '../../Constants/index';
import { Grid, Paper, Button } from '@mui/material';
import FadeLoader from "react-spinners/FadeLoader";
import { QRCodeSVG } from 'qrcode.react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import human from '../../Images/Icons/who.png';

function GenQR({ refresh }) {
  // For History
  const history = useHistory();

  // Set Loading
  const [loading, setLoading] = useState(false);

  // For capture Paper content as PDF
  const printRef = useRef(null);

  // For get data from user login
  const tokenData = JSON.parse(localStorage.getItem(USER_KEY));
  const token = tokenData.token;
  const empCode = tokenData.emp_info[0].emp_code;

  // Set data for get Employee Info from loadData
  const [empName, setEmpName] = useState('');
  const [empSurname, setEmpSurname] = useState('');
  const [empGender, setEmpGender] = useState('');
  const [empPhoto, setEmpPhoto] = useState('');
  const [genCode, setGenCode] = useState('');

  // Full Code QR
  let _fullCodeQR = `https://csms.laotel.com/survey/?code=${genCode}`;

  // for Loading Data
  const loadData = async () => {
    setLoading(true)

    try {
      await Axios.post("Survey/Employee/QR", { "emp_code": empCode }, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
        // Check token Expired
        if (res.data.result_code == '403') {
          Auth.logout(() => {
            history.push("/");
          });
        }

        if (res.data.result_code == "200") {
          setEmpName(res.data.emp_info[0].fNameLa)
          setEmpSurname(res.data.emp_info[0].lNameLa)
          setEmpGender(res.data.emp_info[0].genderID)
          setEmpPhoto(res.data.emp_photo)
          setGenCode(res.data.gen_code)
        }
      })
    } catch (error) {
      // console.log(error)
    }

    setTimeout(() => {
      setLoading(false)
    }, 500);
  }

  useEffect(() => {
    loadData()
  }, [refresh])

  // For Save QR Code as PDF
  const SaveQR = async () => {
    const element = printRef.current;
    if (!element) return;

    const canvas = await html2canvas(element, { scale: 2, useCORS: true });
    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF({
      orientation: canvas.width > canvas.height ? 'landscape' : 'portrait',
      unit: 'px',
      format: [canvas.width, canvas.height],
    });

    pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);
    pdf.save(`QR_${empCode}.pdf`);
  }

  return (
    <>
      {loading ? <>
        <div className='manage_loading'>
          <FadeLoader color={'#ED1C24'} loading={loading} size={10} />
        </div>
      </> : <>
        <Grid container>
          <Grid lg={4} sm={2} xs={12}></Grid>
          <Grid lg={4} sm={8} xs={12}>
            <div ref={printRef}>
              <Paper elevation={10} style={{ padding: 20, marginTop: 10 }}>
                <div className='user_profile_title'>QR Code ຂອງພະນັກງານ</div>

                <center style={{ marginTop: '20px' }}>
                  {empPhoto.length > 0 ?
                    <>
                      <img src={"data:image/gif;base64," + empPhoto} width={100} height={130} className='user_profile_show_photo'></img>
                    </> : <>
                      <img src={human} width={120} height={120} className='user_profile_show_photo' />
                    </>
                  }
                </center>

                <div className='user_profile_tab1'>
                  <Grid container>
                    <Grid item xs={12} className='user_profile_text_title'>
                      ({empCode}) {empGender == 1 ? ('ທ່ານນາງ ') : ('ທ່ານ ')} {empName + ' ' + empSurname}
                    </Grid>
                  </Grid>
                </div>

                <div className='user_profile_tab2'>
                  <center>
                    <QRCodeSVG value={_fullCodeQR} size={280} level='M' includeMargin />
                  </center>

                  <Grid container>
                    <Grid item xs={12} className='user_profile_text_name'>ກະລຸນາສະແກນ ເພື່ອໃຫ້ຄະແນນພະນັກງານ</Grid>
                  </Grid>
                </div>
              </Paper>
            </div>

            <div className='user_profile_tab3'>
              <Grid container>
                <Grid item xs={4}></Grid>
                <Grid item xs={4}>
                  <Button className="user_save_qr_button" fullWidth variant="outlined" onClick={SaveQR}>Save QR</Button>
                </Grid>
                <Grid item xs={4}></Grid>
              </Grid>
            </div>

          </Grid>
          <Grid lg={4} sm={2} xs={12}></Grid>
        </Grid >
      </>}
    </>
  )
}

export default GenQR